var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fs5 lh125 fw7 c1 mb2"},[_vm._v(_vm._s(_vm.$t("cancellation_reason")))]),_c('j-card',{staticClass:"flex-wrap xs-12 xs-right mb6 bg5 p2 c1 fs3"},[_vm._v("\n\t\t"+_vm._s(_vm.cancellationReason)+"\n\t")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }